import './App.css';
import { BsFillArrowUpCircleFill } from 'react-icons/bs'
import Card from './components/Card';
import Heading from './components/Heading';
import Subheading from './components/Subheading';
import Text from './components/Text'
function App() {
  return (
    <div className="App">
      <div className="App-header">
        <div style={{ width: "100vw", minHeight: "100vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
          <div style={{ flexDirection: "column", display: "flex",alignItems:"center" }}>
            <img src={process.env.PUBLIC_URL + "AsteromiteLogoLong.png"} className="App-logo" alt="logo" />

            <div className='text' style={{ width: "60vw", marginTop: "8px", maxWidth: "60vw", textAlign: "center" }}>
              <span>
                <a href='https://www.toptal.com/resume/shahid-sheharyar' > Sheharyar Shahid</a> has created this site to showcase his skills.
              </span>
            </div>

          </div>
        </div>
        <div style={{ width: "100vw", marginTop: "-20vh" }}>

          <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
            <BsFillArrowUpCircleFill color="rgb(32,70,176)" />
            <span style={{ marginLeft: "8px", color: "var(--git-black)", fontSize: "0.8em" }}>
              Keep scrolling to find out more...
            </span>
          </div>
          <div style={{width:"100vw",color:"var(--git-black)",minHeight:"100vh",backgroundColor:"var(--git-black-half)",marginTop:"5vh",paddingTop:"8vh", paddingBottom:"20vh",   }}>
          <Card >
            <Heading >React/React Native developer @BILDIT.CO</Heading>
            <Subheading>React site development</Subheading>
            <Text>I developed a full fledge documentation of BILDIT sdk, which provides exquiste interface to developers and consumers. Here is a glimpse of work done so far.</Text>
            <div style={{width:"100%",display:"flex",flexDirection:"column",alignItems:"center",paddingTop:"5vh",paddingBottom:"5vh"}}>
            <img src={process.env.PUBLIC_URL+"preview.png"}  style={{objectFit:"contain", width:"90%",pointerEvents:"none",border:"0px solid black",marginBottom:"4vh",boxShadow:"0 0 10px black ",touchAction:"none"}} />
            <span style={{ fontSize:"0.7em"  }} >BILDIT documentation site. Click <a href="https://docs.bildit.co/">here</a> to see full website</span>
            </div>
          </Card>

          <Card>
            <span>More highlights coming soon!</span>
          </Card>

          </div>
          <div style={{width:"100%",backgroundColor:"rgb(32,70,176)",fontSize:"0.5em",padding:"1.4vmin",paddingLeft:"5vw", textAlign:"left"}} >
            <span  >Asteromite is property of Sheharyar Shahid {"(c) "}Copyright {" "+new Date().getFullYear()}  </span>
          </div>
        </div>
 
      </div>

    </div>
  );
}

export default App;
